export default __webpack_public_path__ + "static/media/skeleton.dd8b9f41.png";